export default {
  modelName: 'Dodoable',
  attributes: {
    abbr: {
      name: "abbr",
      apiName: "abbr",
      camelName: "abbr",
      underscoreName: "abbr",
      type: "string",
      writeable: true,
      default: null,
    },
    aboutTime: {
      name: "aboutTime",
      apiName: "about_time",
      camelName: "aboutTime",
      underscoreName: "about_time",
      type: "integer",
      writeable: true,
      default: 0,
    },
    ancestry: {
      name: "ancestry",
      apiName: "ancestry",
      camelName: "ancestry",
      underscoreName: "ancestry",
      type: "string",
      writeable: true,
      default: null,
    },
    createdAt: {
      name: "createdAt",
      apiName: "created_at",
      camelName: "createdAt",
      underscoreName: "created_at",
      type: "datetime",
      writeable: true,
      default: null,
    },
    currentable: {
      name: "currentable",
      apiName: "currentable",
      camelName: "currentable",
      underscoreName: "currentable",
      type: "jsonb",
      writeable: true,
      default: "true",
    },
    dodones: {
      name: "dodones",
      apiName: "dodones",
      camelName: "dodones",
      underscoreName: "dodones",
      type: "has_many",
      writeable: true,
      default: null,
      model: "Dodone",
    },
    freeable: {
      name: "freeable",
      apiName: "freeable",
      camelName: "freeable",
      underscoreName: "freeable",
      type: "boolean",
      writeable: true,
      default: false,
    },
    id: {
      name: "id",
      apiName: "id",
      camelName: "id",
      underscoreName: "id",
      type: "integer",
      writeable: false,
      default: null,
    },
    name: {
      name: "name",
      apiName: "name",
      camelName: "name",
      underscoreName: "name",
      type: "string",
      writeable: true,
      default: null,
    },
    settings: {
      name: "settings",
      apiName: "settings",
      camelName: "settings",
      underscoreName: "settings",
      type: "jsonb",
      writeable: true,
      default: "{}",
    },
    slug: {
      name: "slug",
      apiName: "slug",
      camelName: "slug",
      underscoreName: "slug",
      type: "string",
      writeable: true,
      default: null,
    },
    type: {
      name: "type",
      apiName: "type",
      camelName: "type",
      underscoreName: "type",
      type: "string",
      writeable: true,
      default: null,
    },
    typeViewPrefix: {
      name: "typeViewPrefix",
      apiName: "type_view_prefix",
      camelName: "typeViewPrefix",
      underscoreName: "type_view_prefix",
      type: "string",
      writeable: true,
      default: null,
    },
    updatedAt: {
      name: "updatedAt",
      apiName: "updated_at",
      camelName: "updatedAt",
      underscoreName: "updated_at",
      type: "datetime",
      writeable: true,
      default: null,
    },
    user: {
      name: "user",
      apiName: "user",
      camelName: "user",
      underscoreName: "user",
      type: "belongs_to",
      writeable: true,
      default: null,
      model: "User",
    },
    userId: {
      name: "userId",
      apiName: "user_id",
      camelName: "userId",
      underscoreName: "user_id",
      type: "integer",
      writeable: true,
      default: null,
    },
  },
  names: {
    singularUnderscore: "dodoable",
    pluralUnderscore: "dodoables",
    singularDash: "dodoable",
    pluralDash: "dodoables",
    singularCamel: "dodoable",
    pluralCamel: "dodoables",
    singularClass: "Dodoable",
    pluralClass: "Dodoables",
    human: "Dodoable",
  },
  validators: [
    {
      className: "ActiveRecord::Validations::PresenceValidator",
      options: {
        message: "required",
        if: null,
      },
      attributes: [
        "user",
      ],
    },
  ],
  enums: {
  },
}
